<template>
  <div class="examination">
    <div class="text">当前剩余 <span class="points">{{points}}</span> 兑换次数</div>
    <div class="btn" @click="onItemClick"></div>
  </div>
</template>

<script>
import { reactive, toRef, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Dialog } from 'vant'
import api from '@/api'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    const data = reactive({
      points: 0,
      product: {},
    })
    const { activityCode } = route.query

    const onItemClick = () => {
      if (data.points === 0) {
        Dialog.alert({
          message: '该商品已售罄'
        })
        return
      }
      router.push({
        path: '/productDetail',
        query: {
          id: data.product.id,
          activityCode
        }
      })
    }

    onMounted(() => {
      document.title = '健康导诊'
      api.getPoints({ activityCode }).then(res => {
        data.points = res.data
      })
      api
        .getProductList({
          activityCode
        })
        .then(res => {
          if (res.data.length > 0) {
           data.product = res.data[0]
          }
        })

    })


    return {
       points: toRef(data, 'points'),
       onItemClick
    }
  }
}
</script>

<style lang="less" scoped>
.examination {
  min-height: 728px;
  background-color: #2697fe;
  background-image: url('../../assets/examination-bg.png');
  background-repeat: no-repeat;
  background-size: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  .text {
    background: #ABD7FF;
    border-radius: 4px;

    font-size: 12px;
    font-family: Source Han Sans CN;
    color: #006CD2;
    padding: 5px 10px 4px 10px;
    margin-top: 254px;
    .points {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #006CD2;
    }
  }
  .btn {
    width: 257px;
    height: 30px;
    background-image: url('../../assets/examination-btn.png');
    background-repeat: no-repeat;
    background-size: 100%;
    margin-top: 10px;
  }
  .btn:active {
    opacity: 0.8;
  }
 
}
</style>